module.exports = __webpack_public_path__ + "img/wangzizheng.063e3f61.jpg";